import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Alert, Button, ProgressBar } from "react-bootstrap";
import { ButtonChoiceQuestion } from "../components/lecture/ButtonChoiceQuestion";
import { CodeProjectQuestion } from "../components/lecture/CodeProjectQuestion";
import { resetProjectStatus } from "../core/code/loader";
import { saveUserData } from "../core/code/saver";
import { EDITOR_VIEW_NAME, LECTURE_VIEW_NAME } from "../core/constants";
import { translate } from "../core/i18n";
import { loadProjectForLecture } from "../core/project/projectdata";
import { store } from "../core/state";
import { getStartCode } from "../features/coderunner";
import { getRedirectUrl, redirectTo } from "../features/redirect";
import { isResponsiveView } from "../features/responsive";

export const LectureView = () => {
  const [viewData,] = store.useState(LECTURE_VIEW_NAME);
  const [editorState, setEditorState] = store.useState(EDITOR_VIEW_NAME);
  const [lectureState, setLectureState] = useState({
    currentLecture : 0,
    correctAnswers : 0
  })
  const [answerCorrect, setAnswerCorrect] = useState(null);
  const [evaluated, setEvaluated] = useState(false);
  const [finished, setFinished] = useState(false);
  const [currentProjectLoaded, setCurrentProjectLoaded] = useState('');

  const resetEditorCode = async () => {
    const newState = { ...editorState };
    newState.data = {
      ...editorState.data,
      editorCode : editorState?.data?.projectContent?.projectSource,
      editorTabs : undefined,
      executionCode : getStartCode(editorState),
      editorDirty : false
    }

    setEditorState(newState);
    saveUserData();
  }

  const exitRequested = () => {
    if (!finished) {
      //ask user if he wants to abort!
    }
    redirectTo(getRedirectUrl(viewData.cfg?.exitView));
  }

  const correctAnswered = () => {
    setAnswerCorrect(true);
  }

  const wrongAnswered = () => {
    setAnswerCorrect(false);
  }

  const evaluateAnswer = () => {
    if (answerCorrect === null) {
      return;
    } else if (answerCorrect === true) {
      const newLectureState = {
        currentLecture : lectureState.currentLecture,
        correctAnswers : lectureState.correctAnswers + 1
      }
      setLectureState(newLectureState)
    }
    setEvaluated(true);
  }

  const nextQuestion = () => {
    if (finished) {
      redirectTo(getRedirectUrl(viewData.project?.continue));
      return;
    }
    setAnswerCorrect(null);
    setEvaluated(false);
    const newLectureState = {
      currentLecture : lectureState.currentLecture + 1,
      correctAnswers : lectureState.correctAnswers
    }
    setLectureState(newLectureState)
  }

  const hasExit = viewData.cfg?.exitView;
  const exitButton = <button className="btn btn-outline-secondary round-button btn-icon mb-10" title={translate('exit-btn-title')} onClick={exitRequested}>
    <FontAwesomeIcon icon="home" /></button>;

  let currentQuestion;
  if (!viewData.data) {
    currentQuestion = {
      type : "choice",
      question : "Was kommt nach A?",
      answers : [
        { id:1, text : "A: G"},
        { id:2, text : "N: E"},
        { id:3, text : "C: B"},
        { id:4, text : "D: N"}
      ],
      correct : 3,
      hint : "Denke nicht an das Alphabet!"
    };
  } else if (lectureState.currentLecture < viewData.data?.length) {
    currentQuestion = viewData.data[lectureState.currentLecture];
  } else if (lectureState.currentLecture >= viewData.data?.length && !finished) {
    setFinished(true);
  }

  let question;
  if (!finished && currentQuestion?.type === "choice") {
    question = <ButtonChoiceQuestion question={currentQuestion} rightAnswer={correctAnswered} wrongAnswer={wrongAnswered} evaluated={evaluated} />
  } else if (!finished && currentQuestion?.type === "project") {
    if (currentProjectLoaded !== currentQuestion.project) {
      loadProjectForLecture(currentQuestion.project);
      setCurrentProjectLoaded(currentQuestion.project);
    }
    question = <CodeProjectQuestion project={currentQuestion} rightAnswer={correctAnswered} wrongAnswer={wrongAnswered} evaluated={evaluated} />
  }

  const questionArea = (<div className="p-5">
    { question }
  </div>);

  const finishLine = (<div className="p-5">
    <h1>Geschafft!</h1>
    <p>{lectureState.correctAnswers} Fragen von {viewData.data?.length} korrekt beantwortet!</p>
  </div>);

  const responsiveView = isResponsiveView();
  const answerAreaClasses = responsiveView ? "d-grid fixed-bottom p-1" : "d-grid p-1";

  const submitButton = (<Button variant="outline-primary" size="lg" onClick={evaluateAnswer}>
    Bestätigen
  </Button>);

  let buttonVariant = "outline-primary";
  if (answerCorrect === true) {
    buttonVariant = "success"
  } else if (answerCorrect === false) {
    buttonVariant = "danger"
  }
  const continueButton = (<Button variant={buttonVariant} size="lg" onClick={nextQuestion}>
    Weiter
  </Button>);
  const hintAlert = (<Alert>{currentQuestion?.hint}</Alert>)

  const content = <>
      <ProgressBar now={lectureState.currentLecture} min={0} max={viewData.data?.length}/>
      { !finished && questionArea }
      { finished && finishLine }

      <div className={answerAreaClasses}>
          <hr />
          { !finished && !evaluated && submitButton }
          { !answerCorrect && evaluated && hintAlert }
          { (finished || evaluated) && continueButton }
      </div>
  </>;

  const desktopBorder = <div className="container" style={{ maxWidth: 900 }} >
    <div className="text-end">{hasExit && exitButton}</div>
    <div className="rounded-lg shadow mb-5 bg-white border bordersize-15">
      { content }
    </div>
  </div>;

  const mobileBorder = <div className="container">
    { content }
  </div>

  return (<>
    { responsiveView && mobileBorder }
    { !responsiveView && desktopBorder }
  </>);
}
